// extracted by mini-css-extract-plugin
export var button = "ButtonFilled-module--button--yjW-N";
export var text = "ButtonFilled-module--text--siJ-k";